import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import InputField from './InputField';
import DatePicker from './DatePicker';
// import DropDown from './DropDown';
import Toggle from './Toggle';
import { AssessmentTwoTone, GroupAddTwoTone, PersonAddTwoTone } from '@material-ui/icons';
import * as Calc from '../services/CalcService';
import CycleAssessments from './CycleAssessments';
import CycleGroups from './CycleGroups';
import CycleUsers from './CycleUsers';

export default class Cycles extends Component {

    constructor(props) {
        super(props);
        this.reset_state = {
            assessments_view: false,
            groups_view: false,
            users_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            error: false,
            error_message: '',
            querying: true,
            cycles_array: [],
            show_dialogue: false,
            form_view: false,
            editing: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Assessment Cycle'
        }
        this.state = {  //Note: designations and show_closed_cycles not reset
            assessments_view: false,
            show_closed_cycles: false,
            groups_view: false,
            users_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            designations: [],
            error: false,
            error_message: '',
            querying: true,
            cycles_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Assessment Cycle',
            default_doe: ''            
        };
        this.datasheetFieldSpecs = [
            // { field: 'id', headerName: 'Empl. #', width: 90, sortable:false},
            { field: 'groups', headerName: 'Groups', width: 73, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.editGroups(parms)} 
                >
                    <GroupAddTwoTone/>
                </IconButton>
            )},
            { field: 'employees', headerName: 'Individuals', width: 73, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.editUsers(parms)} 
                >
                    <PersonAddTwoTone/>
                </IconButton>
            )},
            { field: 'assessments', headerName: 'Assessments', width: 73, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.editAssessments(parms)} 
                >
                    <AssessmentTwoTone/>
                </IconButton>
            )},
            // { field: 'job_title', headerName: 'For Designation', width: 160},
            { field: 'cycle_name', headerName: 'Cycle Description', width: 260, sortable:false},
            { field: 'cycle_code', headerName: 'Short Code', width: 130},
            { field: 'open_date', headerName: 'Open From', width: 130},
            { field: 'deadline_date', headerName: 'Deadline', width: 130},
            { field: 'employed_from', headerName: 'DOE Cutoff', width: 130, sortable:false},
            { field: 'closed', headerName: 'Closed?', width: 85, sortable:false, align:'center'},
            // { field: 'archived', headerName: 'Archive?', width: 90, sortable:false},
        ]

        this.input_fieldSpecs = [

            // {field: "job_title", headerName: "Applies to Designation?", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "cycle_code", headerName: "Cycle Code", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 4, f_maxLength: 15},
            {field: "cycle_name", headerName: "Cycle Description", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 5, f_maxLength: 50},
    
            {field: "open_date", headerName: "Opens for Submission?", f_inputType:'datepicker', f_required:true, f_show:true},
            {field: "deadline_date", headerName: "Submission Deadline?", f_inputType:'datepicker', f_required:true, f_show:true},
            {field: "employed_from", headerName: "DOE must be on or before?", f_inputType:'datepicker', f_required:true, f_show:true},

            {field: "closed", headerName: "Closed for Submissions?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true},
            {field: "archived", headerName: "Archive this Cycle?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true},
        ]
        this.doeCutoffElement = React.createRef();
    }

    componentDidMount = (show_closed_cycles = false) => {
    //   console.log('designations.length :>> ', this.state.designations.length);

        //async request designation list... run on first mount only...
        // if (this.state.designations.length===0){  
        //     Gserv.sendCommand('query_designations',this.props.gwt)
        //     .then(designations => {
        //         // console.log('designations :>> ', designations);
        //         if (designations.error){
        //             console.log('error on return from Gserv (query_designations) :>> ', designations);
        //             this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
        //         } else if (designations.Result!=="Success"){
        //             console.log('error on return from Gserv (query_designations) :>> ', designations);
        //             this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
        //         } else {
        //             this.setState({designations: designations.Records});
        //         }
        //     }); 
        // }

        //async get latest assessment / cycle matrix...
        

        Gserv.sendCommand('query_open_cycles',this.props.gwt,{show_closed_cycles: show_closed_cycles})
        .then(reply=>{
            // console.log('query_open_cycles reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_open_cycles) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_open_cycles) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let cycle_array = reply.Records;
                    let open_date = null;
                    let deadline_date = null;
                    let employed_from = null;
                    for (var i=0;i<cycle_array.length;i++){
                        open_date = new Date(cycle_array[i].open_date);
                        deadline_date = new Date(cycle_array[i].deadline_date);
                        employed_from = new Date(cycle_array[i].employed_from);
                        cycle_array[i].open_date = open_date.getFullYear() + "-" +  Calc.twoDigit((open_date.getMonth()+1)) + "-" + Calc.twoDigit(open_date.getDate());;
                        cycle_array[i].deadline_date = deadline_date.getFullYear() + "-" +  Calc.twoDigit((deadline_date.getMonth()+1)) + "-" + Calc.twoDigit(deadline_date.getDate());;
                        cycle_array[i].employed_from = employed_from.getFullYear() + "-" +  Calc.twoDigit((employed_from.getMonth()+1)) + "-" + Calc.twoDigit(employed_from.getDate());
                        cycle_array[i].closed = cycle_array[i].closed? "YES" : "";
                        cycle_array[i].archived = cycle_array[i].archived? "YES" : "";
                    }
                }
                this.setState({querying:false, cycles_array:reply.Records?reply.Records : []});

            }
        });
    };

    handleChildStateUpdate = (new_state) => {
        this.setState(new_state);
    }

    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        switch (e.field) {
            case 'show_closed_cycles':
                this.setState({show_closed_cycles:e.value});
                this.componentDidMount(e.value);
                break;

                // case 'include_archived_interventions':
            //     this.setState({include_archived_interventions:e.value});
            //     break;

            // case 'include_unapproved_assessments':
            //     this.setState({include_unapproved_assessments:e.value});
            //     break;

            // case 'include_unapproved_interventions':
            //     this.setState({include_unapproved_interventions:e.value});
            //     break;
        
            default:
                break;
        }
    }

    editAssessments = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row,assessments_view:true, editing: true});
    }

    editGroups = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row,groups_view:true, editing: true});
    }

    editUsers = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row,users_view:true, editing: true});
    }

    processForm = (e) => {
        e.preventDefault();
        // console.log('this.state.form_data :>> ', this.state.form_data);
        this.setState({writing:true, primary_button_enabled:false});
        //set state updating here...
        
        if (this.state.current_record.id){
            //this is an update

            //force 'closed' flag to true, if 'archived' flag is true...
            if (this.state.form_data.archived&&!this.state.form_data.closed){
                let formDataUpdate = this.state.form_data;
                formDataUpdate.closed = true;    
                this.setState({form_data: formDataUpdate})
            }

            Gserv.sendCommand('update_cycle',this.props.gwt,{
                form_data : this.state.form_data,
                id : this.state.current_record.id
            })
            .then(reply => {
                // console.log('update reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (update_cycle) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409) {
                    console.log('error on return from Gserv (update_cycle) :>> ', reply);
                    this.setState({error:true,error_message:"A cycle with this code or name already exists.",querying:false});
                } else if (reply.Result!=="Success") {
                    console.log('error on return from Gserv (update_cycle) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState(this.reset_state);
                    this.componentDidMount();
                }
            });           

        } else {
            //this is a create
            Gserv.sendCommand('create_cycle',this.props.gwt,{
                form_data : this.state.form_data
            })
            .then(reply => {
                // console.log('create reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (create_cycle) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409){
                    console.log('error on return from Gserv (create_cycle) :>> ', reply);
                    this.setState({error:true,error_message:"A cycle with this code or name already exists.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (create_cycle) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState(this.reset_state);
                    this.componentDidMount();
                }
            });
        }
    }

    handleFieldUpdate = (fieldObj) => {
        // console.log('called field update...');
        // console.log('child field update:',fieldObj);
        // console.log(this.state.current_record);
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value===''){fieldObj.value=null}

        //Transpose 'YES' fields to true for toggle inputs...
        if ((fieldObj.field==='archived'||fieldObj.field==='closed')&&fieldObj.value==='YES'){fieldObj.value=true}

        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;

        //Custom - set DOE cutoff to open date by default when entered...
        if (fieldObj.value&&fieldObj.field==='open_date'&&!myFormData.employed_from&&!this.state.editing){
            // console.log('default DOE triggered...')
            myFormData.employed_from = fieldObj.value;
            this.doeCutoffElement.current.updateValue(fieldObj.value);
        }

        this.setState({form_data:myFormData});
        // console.log('current_record value : ',this.state.current_record[fieldObj.field]);
        // console.log('New value : ', fieldObj.value);
        // eslint-disable-next-line eqeqeq
        if(this.state.current_record[fieldObj.field]!=fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 
    }

    handleUpdate = (record) => {
        // console.log('record for update :>> ', record);
        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({current_record:record.row,form_view:true,editing:true,primary_button_enabled:false,primary_button_text:'Update Assessment Cycle'});
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);

        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({deleting:true,querying:true});
        Gserv.sendCommand('delete_cycle',this.props.gwt,{
            cycle_id: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (delete_cycle) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (delete_cycle) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState(this.reset_state);
                this.componentDidMount();
            }
        });

    }
    
    resetMe = () => {
        this.setState(this.reset_state);
        this.componentDidMount();
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                {!this.state.assessments_view&&!this.state.groups_view&&!this.state.users_view&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        // height:'22vh',
                        // maxWidth:680,
                        // minWidth:680
                        width:1250
                    }}
                >
                   <Typography
                    color='primary'
                    style={{paddingTop:15, paddingBottom:15}}
                   >
                       Assessment Cycles
                   </Typography>

                   {!this.state.form_view&&   
                   <Grid
                    container
                    direction='row'
                    justifyContent='center'
                    alignContent='center'
                    style={{paddingBottom:15}}
                   >

                    <Grid item xs={4}></Grid>
                    <Grid item xs={4}>
                        <Button
                            variant='contained'
                            color='primary'
                            type='submit'
                            onClick={()=>this.setState({form_view:true,editing: false,primary_button_text:'Create Assessment Cycle',current_record:{},form_data:{}})}
                            disabled={this.state.form_view}
                        >
                            Create
                        </Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Toggle 
                            fieldMap={{field: "show_closed_cycles", headerName: "Show Closed Cycles?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                            setField={this.handleToggleChange}
                        />
                    </Grid>
                    
                   </Grid>}
                </Paper>
                </Grid>}

                <Grid item>
                    <Typography color='secondary' style={{Width:1250,maxWidth:1250, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

                {/* {this.state.querying&&
                <Grid item>
                    <br/>
                    <Settings className='icn-spinner' /> Querying...
                </Grid>} */}

                {/* Datagrid goes here */}
                {!this.state.form_view&&!this.state.assessments_view&&!this.state.groups_view&&!this.state.users_view&&
                <DatasheetView 
                    dataset={this.state.cycles_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={true}
                    edit={true}
                    handleDelete={this.handleDelete}
                    handleEdit={this.handleUpdate}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={8}
                />}

                {this.state.form_view&&!this.state.assessments_view&&!this.state.groups_view&&!this.state.users_view&&
                <Paper
                    elevation={3}
                >
                    <form onSubmit={this.processForm}>
                        <br/>
                        <Grid 
                            container 
                            direction='column'
                            alignItems='baseline'
                            justifyContent='flex-start'
                            spacing={1}
                            style={{width:'70%', marginLeft:'30%', marginBottom:'10px'}}
                        >
                            {/* <DropDown fieldMap={this.input_fieldSpecs[0]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={this.state.designations} disabled={this.state.writing}/> */}
                            <InputField fieldMap={this.input_fieldSpecs[0]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            <div style={{width:'400px', paddingLeft:'5px'}}>
                                <InputField fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>
                            <DatePicker fieldMap={this.input_fieldSpecs[2]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            <DatePicker fieldMap={this.input_fieldSpecs[3]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            <DatePicker fieldMap={this.input_fieldSpecs[4]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing} ref={this.doeCutoffElement}/>
                            {this.state.editing&&
                            <div>
                                <Toggle fieldMap={this.input_fieldSpecs[5]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                                <Toggle fieldMap={this.input_fieldSpecs[6]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>}
                        </Grid>
                        <Button 
                            color='primary'
                            variant='outlined'
                            disabled={!this.state.primary_button_enabled}
                            type='submit'
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            {this.state.primary_button_text}
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.setState({form_view:false, editing:false})}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            Cancel
                        </Button>
                    </form>
                </Paper>}

                {this.state.assessments_view&&
                <CycleAssessments 
                    cycle={this.state.current_record}
                    gwt={this.props.gwt}
                    setParentState={this.handleChildStateUpdate}
                />}

                {this.state.groups_view&&
                <CycleGroups 
                    cycle={this.state.current_record}
                    gwt={this.props.gwt}
                    setParentState={this.handleChildStateUpdate}
                />}

                {this.state.users_view&&
                <CycleUsers
                    cycle={this.state.current_record}
                    gwt={this.props.gwt}
                    setParentState={this.handleChildStateUpdate}
                />}

            </Grid>
        );
    }
    
}